export default __webpack_public_path__ + "static/media/report.b159419f.svg";